module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"set_minimimum_order":"Set Minimum Order Amount","store_has_minimum_order":"This store has minimum order amount"},"id":{"set_minimimum_order":"Set amaun minimum untuk Order","store_has_minimum_order":"Store ini ada amaun order minimum"}}')
  delete Component.options._Ctor
}
